import { useAtomValue } from 'jotai';

import { activeSegmentationsAtom, totalFramesAtom } from '@store';

import * as css from './PositionMarker.css';

const IMPACT_POSITION = 'P7';

export const PositionMarker = ({ position, progress }: { position: string; progress: number }) => {
    return (
        <div
            className={css.pPositionMarker({ highlighted: position === IMPACT_POSITION })}
            style={{ left: `${progress}%` }}
        />
    );
};

export const PositionMarkerList = () => {
    const totalFrames = useAtomValue(totalFramesAtom);
    const segmentationEntries = useAtomValue(activeSegmentationsAtom);
    return segmentationEntries.map(([position, frame]) => (
        <PositionMarker key={position} position={position} progress={(frame / totalFrames) * 100} />
    ));
};
